




















import { Component, Prop, Vue } from "vue-property-decorator";
import { DebugHelper } from "@/helper/debugHelper";

@Component({
  components: {
  }
})

export default class signInAlertModal extends Vue {

    private title = "ログインされていません";
    private message = "ラベル屋さんアカウントにログインされていません。<br>この機能を利用するためにはログインが必要です。";

    private cancel(){
        history.back();
    }

    private goSignIn(){
        this.$emit("goSignIn");
    }
    
    private get userConfigButtonColorStyle(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
}
